import { Alert, Snackbar, SnackbarCloseReason } from '@mui/material';
import { useEffect, useState } from 'react';

import { useErrorContext } from '@/context/ErrorContext';

export const ErrorToast = () => {
    const [open, setOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>();
    const { error } = useErrorContext();

    useEffect(() => {
        if (error) {
            setErrorMessage(error.message);
            setOpen(true);
        }
    }, [error]);

    function handleClose(_event: unknown, reason?: SnackbarCloseReason) {
        if (reason === 'clickaway') {
            return;
        }

        setErrorMessage(undefined);
        setOpen(false);
    }

    return (
        <Snackbar
            open={open}
            autoHideDuration={5000}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            onClose={handleClose}
        >
            <Alert onClose={handleClose} severity="error" variant="filled" sx={{ width: '100%', alignItems: 'center' }}>
                {errorMessage}
            </Alert>
        </Snackbar>
    );
};
